import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import RestaurantHomePage from './pages/restaurant-home-page';
import RestaurantDetailsPage from './pages/restaurant-details';
import CartPage from './pages/cart';
import AccountPage from './pages/account';
import OrdersPage from './pages/orders';
import FavoritesPage from './pages/favorites';
import Footer from "components/Footer";
import SignupPage from "pages/SignUp";
import CompleteOrderPage from "pages/Complete-order";
import HomeRedirect from "pages/HomeRedirect";
import MarketHomePage from "pages/market-home-page";
import MarketDetailsPage from "pages/market-details";
import PopularRestaurant from "pages/restaurant-home-page/tabsContent/PopularRestaurant";
import PopularMarket from "pages/restaurant-home-page/tabsContent/PopularMarket";
import TermsAndConditionsPage from "pages/TermsAndConditionsPage";
import ProtectedRoute from "ProtectedRoute";
import MyAddresses from "pages/MyAddresses";
import AddAddress from "pages/AddAddress";
import PrivacyPolicyPage from "pages/PrivacyPolicyPage";
import CompleteQuickOrderPage from "pages/CompleteQuickOrderPage";
import OrderDetailsPage from "pages/order-details";
import ReviewsPage from "pages/ReviewsPage";
import PendingRateOrderGate from "components/rating/PendingRateOrderGate";
import { OrderReviewModalProvider } from "contexts/OrderReviewModalContext";

const Routes = () => {
  return (
    <BrowserRouter>
      <OrderReviewModalProvider>
      <PendingRateOrderGate />
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        
        <Route path="/" element={<HomeRedirect />} />
        <Route path="/restaurant-home-page" element={
          <ProtectedRoute>
          <RestaurantHomePage />
          </ProtectedRoute>
          } />
        <Route path="/market-home-page" element={
          <ProtectedRoute>
          <MarketHomePage />
          </ProtectedRoute>
          } />
        <Route path="/restaurant/:slug" element={
          <ProtectedRoute>
          <RestaurantDetailsPage />
          </ProtectedRoute>
          } />
        <Route path="/market/:slug" element={
          <ProtectedRoute>
          <MarketDetailsPage />
          </ProtectedRoute>
          }
           />
        <Route path="/cart" element={
          <ProtectedRoute>
          <CartPage />
          </ProtectedRoute>
          } />
        <Route path="/orders" element={
          <ProtectedRoute>
          <OrdersPage />
          </ProtectedRoute>
          } />
        <Route path="/orders/:slug" element={
          <ProtectedRoute>
          <OrderDetailsPage />
          </ProtectedRoute>
          } />
        <Route path="/favorites" element={
          <ProtectedRoute>
          <FavoritesPage />
          </ProtectedRoute>
          } />
        <Route path="/account" element={
          <ProtectedRoute>
          <AccountPage />
          </ProtectedRoute>
          } />
        <Route path="/completeOrder" element={
          <ProtectedRoute>
          <CompleteOrderPage />
          </ProtectedRoute>
          } />

           <Route path="/completeQuickOrder" element={
          <ProtectedRoute>
          <CompleteQuickOrderPage />
          </ProtectedRoute>
          } />

        <Route path="/restaurants" element={
          <ProtectedRoute>
          <PopularRestaurant />
          </ProtectedRoute>
          } />
        <Route path="/markets" element={
          <ProtectedRoute>
          <PopularMarket />
          </ProtectedRoute>
          } />

          <Route path="/my-addresses" element={
          <ProtectedRoute>
          <MyAddresses />
          </ProtectedRoute>
          } />

          <Route path="/add-address" element={
          <ProtectedRoute>
          <AddAddress />
          </ProtectedRoute>
          } />

          <Route path="/restaurant/:slug/reviews" 
          element={
             <ProtectedRoute>
          <ReviewsPage type="restaurant" />
          </ProtectedRoute>
          } />

          <Route path="/market/:slug/reviews"
           element={
             <ProtectedRoute>
          <ReviewsPage type="market" />
          </ProtectedRoute>
           } />

        <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/signup" element={<SignupPage />} />
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      
      </ErrorBoundary>
      </OrderReviewModalProvider>
    </BrowserRouter>
  );
};

export default Routes;
